// extracted by mini-css-extract-plugin
export default {"wrap":"SF-z","subtitle":"TF-z","contentWrap":"UF-z","imgWrap":"VF-z","heading":"WF-z","copy":"XF-z"};